/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const ChevronsLeftRightEllipsis = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "m18 8 4 4-4 4" }],
    ["path", { d: "m6 8-4 4 4 4" }],
    ["path", { d: "M8 12h.01" }],
    ["path", { d: "M12 12h.01" }],
    ["path", { d: "M16 12h.01" }]
  ]
];

export { ChevronsLeftRightEllipsis as default };
//# sourceMappingURL=chevrons-left-right-ellipsis.js.map
